import { render, staticRenderFns } from "./Agregado.vue?vue&type=template&id=5c54db04&scoped=true"
import script from "./Agregado.vue?vue&type=script&lang=js"
export * from "./Agregado.vue?vue&type=script&lang=js"
import style0 from "./Agregado.vue?vue&type=style&index=0&id=5c54db04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54db04",
  null
  
)

export default component.exports